module.exports = __webpack_public_path__ + "static/img/pic1.b850276.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic1.png
// module id = 0Oa+
// module chunks = 0